import { useEffect, useRef } from "react"

/**
 * アプリ起動時（完全終了からの起動）を検知するhook
 *
 * 用途:
 * - アプリが完全に終了した状態から起動したことを記録
 * - 実際のキャッシュクリアは useInboxData で行う（APIアクセスが必要なため）
 *
 * 設計思想:
 * - このhookはRecoilManagedAppコンポーネントで呼び出される
 * - Recoilの初期化は、アプリが完全に終了した時のみ実行される
 * - バックグラウンド復帰時はRecoilの状態が保持されるため、このhookは実行されない
 * - キャッシュの無効化判断は useInboxData で行う（最新の連絡をチェックしてから判断）
 */

// アプリ起動フラグ（グローバル）
// useInboxData で初回マウント時にこのフラグをチェックして新着確認を行う
let isAppJustLaunched = true

export const getIsAppJustLaunched = (): boolean => isAppJustLaunched
export const clearAppJustLaunchedFlag = (): void => {
  isAppJustLaunched = false
}

export const useAppLaunchCacheClear = () => {
  const hasLogged = useRef(false)

  useEffect(() => {
    // 既にログ済みの場合はスキップ（二重実行防止）
    if (hasLogged.current) {
      return
    }

    console.log("[Cache] App launched - will check for new data on inbox screen")

    // フラグを立てる（useInboxDataで新着チェックを行う）
    isAppJustLaunched = true
    hasLogged.current = true
  }, [])
}
